var kotemplates = require('../../template/kotemplates');

module.exports = {
  appList: {
    url: "#/appList",
    initRoute: kotemplates.registerAppList,
    page: require("../../component/appList/appListIndex.html"),
  },
  appSort: {
    url: "#/appSort",
    initRoute: kotemplates.registerAppListSort,
    page: require("../../component/appSort/appSortIndex.html"),
  },
  appManager: {
    url: "#/appManager",
    initRoute: kotemplates.registerManagerDetail,
    page: require("../../component/appManager/appManagerIndex.html"),
  },
  appConfig: {
    url: "#/appConfig/:id",
    initRoute: kotemplates.registerAuthList,
    page: require("../../component/appConfig/appConfigIndex.html"),
  },
  manageAuth: {
    url: "#/manageAuth/:accountName/:appCode/:appId",
    initRoute: kotemplates.registerManageAuth,
    page: require("../../component/appConfig/template/manageAuthIndex.html"),
  },
  editAttr: {
    url: "#/editAttr/:id/:appId",
    initRoute: kotemplates.registerEditAttr,
    page: require("../../component/appConfig/template/editAttrIndex.html"),
  },
  recordIndex: {
    url: "#/recordIndex/:id/:appId/:name",
    initRoute: kotemplates.registerRecord,
    page: require("../../component/appConfig/template/recordIndex.html"),
  },
}


//////////////////
// WEBPACK FOOTER
// ./src/routes/config/applist.js
// module id = 250
// module chunks = 0